import React from 'react'

// styles
import { PageContainer } from '../../styles/Themes/StylesTheme1/MyAccountStyles'

export default function MyAccount() {
    return (
        <PageContainer></PageContainer>
    )
}
